export const VESSEL_CLASS_NAME = "highcharts-vessel";
export const ARROW_CLASS_NAME = "highcharts-wind-arrow";
export const WIND_SPEED_TEXT_CLASS_NAME = "highcharts-wind-speed-text";
export const DATE_TIME_TEXT_CLASS_NAME = "highcharts-datetime-text";

/* COLOR */
export const GRAPH_COLORS = {
  VESSEL: "#BCE5F7",
  ARROW: "#2D9CDB",
  BACKGROUND: "#3B4558",
  LINE: "#CECECE",
};

export const MAP_COLORS = {
  PERIOD_ACTUAL: "#BCE5F7",
  ACTUAL: "#1BA9E9",
  USUAL: "#3BD37B",
  RECOMMENDED: "#E27070",
  MAIN_ENGINE_FUEL_CONSUMPUTION: "#008FCF",
  GENERATOR_FUEL_CONSUMPUTION: "#6FC6ED",
  BOILER_FUEL_CONSUMPUTION: "#CCEEFD",
  ENGINE_FUEL_CONSUMPUTION_PER_MILE: "#5D96D8",
  SPEED_THROUGH_WATER: "#E27070",
  AVERAGE_ENGINE_RPM: "#61C478",
  ACCUMULATED_DISTANCE: "#B083D2",
  ACCUMULATED_SECONDS: "#DD864B",
  OPERATION_RATE: "#E8AE00",
};

/* map */
export const VOYAGE_TABLE_HEADERS = {
  accumulatedDistance: {
    value: "航海距離",
    unit: "nm",
    isTimeFormat: false,
  },
  accumulatedSeconds: {
    value: "航海時間",
    unit: "h",
    isTimeFormat: true,
  },
  averageSpeedThroughWater: {
    value: "平均対水速力",
    unit: "kt",
    isTimeFormat: false,
  },
  mainEngineFuelConsumption: {
    value: "主機燃料消費量",
    unit: "L",
    isTimeFormat: false,
  },
  mainEngineFuelConsumptionPerNm: {
    value: "主機燃料消費量(nm)",
    unit: "L/nm",
    isTimeFormat: false,
  },
  mainEngineFuelConsumptionPerHour: {
    value: "主機燃料消費量(h)",
    unit: "L/h",
    isTimeFormat: false,
  },
};

export const PERIOD_TABLE_HEADERS = {
  accumulatedDistance: "航行距離",
  accumulatedSeconds: "航行時間",
  averageSpeedOverGround: "対地速力(平均)",
  mainEngineFuelConsumption: "主機燃料消費量",
  mainEngineFuelConsumptionPerNm: "主機燃料消費量(nm)",
  mainEngineFuelConsumptionPerHour: "主機燃料消費量(h)",
};

const CHART_COLUMN_WIDTH = 30;

export const CHART_SERIES_KEY = {
  MAIN_ENGINE_FUEL_CONSUMPUTION: "main_engine_fuel_consumption",
  GENERATOR_FUEL_CONSUMPTION: "generator_fuel_consumption",
  BOILER_FUEL_CONSUMPTION: "boiler_fuel_consumption",
  AVERAGE_SPEED_THROUGH_WATER: "average_speed_through_water",
  WIND_SPEED: "wind_speed",
  WIND_DIRECTION: "wind_direction",
  ENGINE_FUEL_CONSUMPUTION_PER_MILE: "engine_fuel_consumpution_per_mile",
  AVERAGE_ENGINE_RPM: "average_engine_rpm",
  ACCUMULATED_DISTANCE: "accumulated_distance",
  ACCUMULATED_SECONDS: "accumulated_seconds",
  OPERATION_RATE: "operation_rate",
};

/* Chart */
export const ALL_CHART_SERIES = [
  {
    key: CHART_SERIES_KEY.MAIN_ENGINE_FUEL_CONSUMPUTION,
    enabled: true,
    showSwitch: true,
    name: "主機燃料消費量",
    type: "column",
    valueSuffix: "L",
    color: MAP_COLORS.MAIN_ENGINE_FUEL_CONSUMPUTION,
    data: [],
    showInLegend: false,
    pointWidth: CHART_COLUMN_WIDTH,
    showGraphData: true,
  },
  {
    key: CHART_SERIES_KEY.GENERATOR_FUEL_CONSUMPTION,
    enabled: true,
    showSwitch: true,
    name: "発電機燃料消費量",
    color: MAP_COLORS.GENERATOR_FUEL_CONSUMPUTION,
    type: "column",
    valueSuffix: "L",
    data: [],
    showInLegend: false,
    pointWidth: CHART_COLUMN_WIDTH,
    showGraphData: true,
  },
  {
    key: CHART_SERIES_KEY.BOILER_FUEL_CONSUMPTION,
    enabled: true,
    showSwitch: true,
    name: "ボイラー燃料消費量",
    color: MAP_COLORS.BOILER_FUEL_CONSUMPUTION,
    type: "column",
    valueSuffix: "L",
    data: [],
    showInLegend: false,
    pointWidth: CHART_COLUMN_WIDTH,
    showGraphData: true,
  },
  {
    key: CHART_SERIES_KEY.AVERAGE_SPEED_THROUGH_WATER,
    enabled: true,
    showSwitch: true,
    name: "対水速力",
    color: MAP_COLORS.SPEED_THROUGH_WATER,
    valueSuffix: "kt",
    data: [],
    showInLegend: false,
    pointWidth: CHART_COLUMN_WIDTH,
    showGraphData: true,
    icon: require("@/assets/images/fuel-consumption/icon/speed_through_water.svg"),
  },
];

export const ALL_CHART_SERIES_MONTHLY = [
  {
    key: CHART_SERIES_KEY.MAIN_ENGINE_FUEL_CONSUMPUTION,
    enabled: true,
    showSwitch: true,
    name: "主機燃料消費量",
    type: "column",
    valueSuffix: "L",
    color: MAP_COLORS.MAIN_ENGINE_FUEL_CONSUMPUTION,
    data: [],
    showInLegend: false,
    pointWidth: CHART_COLUMN_WIDTH,
    showGraphData: true,
  },
  {
    key: CHART_SERIES_KEY.GENERATOR_FUEL_CONSUMPTION,
    enabled: true,
    showSwitch: true,
    name: "発電機燃料消費量",
    color: MAP_COLORS.GENERATOR_FUEL_CONSUMPUTION,
    type: "column",
    valueSuffix: "L",
    data: [],
    showInLegend: false,
    pointWidth: CHART_COLUMN_WIDTH,
    showGraphData: true,
  },
  {
    key: CHART_SERIES_KEY.BOILER_FUEL_CONSUMPTION,
    enabled: true,
    showSwitch: true,
    name: "ボイラー燃料消費量",
    color: MAP_COLORS.BOILER_FUEL_CONSUMPUTION,
    type: "column",
    valueSuffix: "L",
    data: [],
    showInLegend: false,
    pointWidth: CHART_COLUMN_WIDTH,
    showGraphData: true,
  },
  {
    key: CHART_SERIES_KEY.ENGINE_FUEL_CONSUMPUTION_PER_MILE,
    enabled: true,
    showSwitch: true,
    name: "燃料消費量",
    color: MAP_COLORS.ENGINE_FUEL_CONSUMPUTION_PER_MILE,
    valueSuffix: "L/mile",
    data: [],
    showInLegend: false,
    pointWidth: CHART_COLUMN_WIDTH,
    showGraphData: true,
    icon: require("@/assets/images/fuel-consumption/icon/engine_fuel_consumpution_per_mile.svg"),
  },
  {
    key: CHART_SERIES_KEY.AVERAGE_SPEED_THROUGH_WATER,
    enabled: true,
    showSwitch: true,
    name: "対水速力",
    color: MAP_COLORS.SPEED_THROUGH_WATER,
    valueSuffix: "kt",
    data: [],
    showInLegend: false,
    pointWidth: CHART_COLUMN_WIDTH,
    showGraphData: true,
    icon: require("@/assets/images/fuel-consumption/icon/speed_through_water.svg"),
  },
  {
    key: CHART_SERIES_KEY.AVERAGE_ENGINE_RPM,
    enabled: true,
    showSwitch: true,
    name: "回転数",
    color: MAP_COLORS.AVERAGE_ENGINE_RPM,
    valueSuffix: "rpm",
    data: [],
    showInLegend: false,
    pointWidth: CHART_COLUMN_WIDTH,
    showGraphData: true,
    icon: require("@/assets/images/fuel-consumption/icon/average_engine_rpm.svg"),
  },
];

export const ALL_CHART_SERIES_YEARLY = [
  {
    key: CHART_SERIES_KEY.MAIN_ENGINE_FUEL_CONSUMPUTION,
    enabled: true,
    showSwitch: true,
    name: "主機燃料消費量",
    type: "column",
    valueSuffix: "L",
    color: MAP_COLORS.MAIN_ENGINE_FUEL_CONSUMPUTION,
    data: [],
    showInLegend: false,
    pointWidth: CHART_COLUMN_WIDTH,
    showGraphData: true,
  },
  {
    key: CHART_SERIES_KEY.GENERATOR_FUEL_CONSUMPTION,
    enabled: true,
    showSwitch: true,
    name: "発電機燃料消費量",
    color: MAP_COLORS.GENERATOR_FUEL_CONSUMPUTION,
    type: "column",
    valueSuffix: "L",
    data: [],
    showInLegend: false,
    pointWidth: CHART_COLUMN_WIDTH,
    showGraphData: true,
  },
  {
    key: CHART_SERIES_KEY.BOILER_FUEL_CONSUMPTION,
    enabled: true,
    showSwitch: true,
    name: "ボイラー燃料消費量",
    color: MAP_COLORS.BOILER_FUEL_CONSUMPUTION,
    type: "column",
    valueSuffix: "L",
    data: [],
    showInLegend: false,
    pointWidth: CHART_COLUMN_WIDTH,
    showGraphData: true,
  },
  {
    key: CHART_SERIES_KEY.ENGINE_FUEL_CONSUMPUTION_PER_MILE,
    enabled: true,
    showSwitch: true,
    name: "燃料消費量",
    color: MAP_COLORS.ENGINE_FUEL_CONSUMPUTION_PER_MILE,
    valueSuffix: "L/mile",
    data: [],
    showInLegend: false,
    pointWidth: CHART_COLUMN_WIDTH,
    showGraphData: true,
    icon: require("@/assets/images/fuel-consumption/icon/engine_fuel_consumpution_per_mile.svg"),
  },
  {
    key: CHART_SERIES_KEY.AVERAGE_SPEED_THROUGH_WATER,
    enabled: true,
    showSwitch: true,
    name: "対水速力",
    color: MAP_COLORS.SPEED_THROUGH_WATER,
    valueSuffix: "kt",
    data: [],
    showInLegend: false,
    pointWidth: CHART_COLUMN_WIDTH,
    showGraphData: true,
    icon: require("@/assets/images/fuel-consumption/icon/speed_through_water.svg"),
  },
  {
    key: CHART_SERIES_KEY.AVERAGE_ENGINE_RPM,
    enabled: true,
    showSwitch: true,
    name: "回転数",
    color: MAP_COLORS.AVERAGE_ENGINE_RPM,
    valueSuffix: "rpm",
    data: [],
    showInLegend: false,
    pointWidth: CHART_COLUMN_WIDTH,
    showGraphData: true,
    icon: require("@/assets/images/fuel-consumption/icon/average_engine_rpm.svg"),
  },
  {
    key: CHART_SERIES_KEY.ACCUMULATED_DISTANCE,
    enabled: true,
    showSwitch: true,
    name: "航海距離",
    color: MAP_COLORS.ACCUMULATED_DISTANCE,
    valueSuffix: "nm",
    data: [],
    showInLegend: false,
    pointWidth: CHART_COLUMN_WIDTH,
    showGraphData: true,
    icon: require("@/assets/images/fuel-consumption/icon/accumulated_distance.svg"),
  },
  {
    key: CHART_SERIES_KEY.ACCUMULATED_SECONDS,
    enabled: true,
    showSwitch: true,
    name: "航海時間",
    color: MAP_COLORS.ACCUMULATED_SECONDS,
    valueSuffix: "h",
    data: [],
    showInLegend: false,
    pointWidth: CHART_COLUMN_WIDTH,
    showGraphData: true,
    icon: require("@/assets/images/fuel-consumption/icon/accumulated_seconds.svg"),
  },
  {
    key: CHART_SERIES_KEY.OPERATION_RATE,
    enabled: true,
    showSwitch: true,
    name: "主機稼働率",
    color: MAP_COLORS.OPERATION_RATE,
    valueSuffix: "%",
    data: [],
    showInLegend: false,
    pointWidth: CHART_COLUMN_WIDTH,
    showGraphData: true,
    icon: require("@/assets/images/fuel-consumption/icon/operation_rate.svg"),
  },
];

/* Objcet Path */
export const DIVIDE_LINE_PATH = ["M", 0.5, 0.5, "V", 48];

export const GRAPH_VESSEL_PATH = [
  "M",
  0.422011,
  27,
  "L",
  0.189454,
  26.1697,
  "L",
  0.189454,
  9.76352,
  "L",
  0.189454,
  6.95758,
  "V",
  6.75716,
  "V",
  6.49947,
  "V",
  5.92683,
  "C",
  0.189454,
  3.40202,
  3.25922,
  -9.9889e-7,
  4.18945,
  -9.9889e-7,
  "C",
  5.11969,
  -9.9889e-7,
  8.18945,
  3.0298,
  8.18945,
  5.92683,
  "V",
  6.49947,
  "V",
  8.30329,
  "L",
  8.14294,
  24.3659,
  "V",
  26.1697,
  "L",
  7.9569,
  27,
  "H",
  0.422011,
  "Z",
];

export const GRAPH_ARROW_PATH = [
  "M",
  4.35355,
  0.355701,
  "C",
  4.15829,
  0.16044,
  3.84171,
  0.16044,
  3.64645,
  0.355701,
  "L",
  0.464465,
  3.53768,
  "C",
  0.269203,
  3.73294,
  0.269203,
  4.04953,
  0.464465,
  4.24479,
  "C",
  0.659727,
  4.44005,
  0.97631,
  4.44005,
  1.17157,
  4.24479,
  "L",
  4,
  1.41636,
  "L",
  6.82843,
  4.24479,
  "C",
  7.02369,
  4.44005,
  7.34027,
  4.44005,
  7.53553,
  4.24479,
  "C",
  7.7308,
  4.04953,
  7.7308,
  3.73294,
  7.53553,
  3.53768,
  "L",
  4.35355,
  0.355701,
  "Z",
  "M",
  4.5,
  23.8735,
  "L",
  4.5,
  0.709255,
  "L",
  3.5,
  0.709255,
  "L",
  3.5,
  23.8735,
  "L",
  4.5,
  23.8735,
  "Z",
];
